module.exports = __webpack_public_path__ + "img/welcome-4.63b56079.png";